import { is } from 'effector';
export function readonly(source) {
  if (!is.targetable(source)) {
    return source;
  }
  if (is.store(source, {
    sid: "-kqkmsc"
  })) {
    return source.map(value => value, {
      skipVoid: false
    });
  }
  if (is.event(source, {
    sid: "-kodgew"
  })) {
    return source.map(value => value);
  }
  return source;
}